/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBasicBbsContentPageListRespVo } from './GetBasicBbsContentPageListRespVo';
import {
    GetBasicBbsContentPageListRespVoFromJSON,
    GetBasicBbsContentPageListRespVoFromJSONTyped,
    GetBasicBbsContentPageListRespVoToJSON,
    GetBasicBbsContentPageListRespVoToJSONTyped,
} from './GetBasicBbsContentPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetBasicBbsContentPageListRespVo
 */
export interface PageDataGetBasicBbsContentPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetBasicBbsContentPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetBasicBbsContentPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetBasicBbsContentPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetBasicBbsContentPageListRespVo>}
     * @memberof PageDataGetBasicBbsContentPageListRespVo
     */
    records?: Array<GetBasicBbsContentPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetBasicBbsContentPageListRespVo interface.
 */
export function instanceOfPageDataGetBasicBbsContentPageListRespVo(value: object): value is PageDataGetBasicBbsContentPageListRespVo {
    return true;
}

export function PageDataGetBasicBbsContentPageListRespVoFromJSON(json: any): PageDataGetBasicBbsContentPageListRespVo {
    return PageDataGetBasicBbsContentPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetBasicBbsContentPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetBasicBbsContentPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetBasicBbsContentPageListRespVoFromJSON)),
    };
}

export function PageDataGetBasicBbsContentPageListRespVoToJSON(json: any): PageDataGetBasicBbsContentPageListRespVo {
    return PageDataGetBasicBbsContentPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetBasicBbsContentPageListRespVoToJSONTyped(value?: PageDataGetBasicBbsContentPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetBasicBbsContentPageListRespVoToJSON)),
    };
}

